import { useState } from "react";
import { Box, Button, InputBase, Typography } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { errorMessage, sendContact } from "../services/veysoApi";
import { tokens } from "../theme";

/**
 * Email field with a button inside a pill. Sends the address through the existing contact endpoint.
 * `tone="dark"` is for the footer; `tone="light"` is for cards on light sections.
 */
export default function EmailCapture({ button = "Join the list", note, tone = "light", message = "Please add me to the VEYSO list.", icon = true }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ busy: false, done: false, error: "" });
  const dark = tone === "dark";
  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, done: false, error: "" });
    try {
      await sendContact({ name: "Email signup", email, message });
      setState({ busy: false, done: true, error: "" });
    } catch (err) {
      setState({ busy: false, done: false, error: errorMessage(err) });
    }
  };
  if (state.done) return <Typography sx={{ fontSize: 15, color: dark ? "#fff" : tokens.mossBtn }}>Thanks. You are on the list.</Typography>;
  return (
    <Box>
      <Box
        component="form" onSubmit={submit}
        sx={{ display: "flex", alignItems: "center", gap: 1, borderRadius: 999, pl: 2.25, pr: 0.6, py: 0.6,
          background: dark ? "transparent" : tokens.sand, border: `1px solid ${dark ? "rgba(255,255,255,.4)" : "#D9C9B4"}` }}
      >
        {icon && <MailOutlineIcon sx={{ fontSize: 18, color: dark ? "rgba(255,255,255,.7)" : tokens.muted }} />}
        <InputBase
          type="email" required placeholder="Your email address" value={email} onChange={(e) => setEmail(e.target.value)}
          inputProps={{ maxLength: 200, "aria-label": "Email address" }}
          sx={{ flex: 1, fontSize: 15, color: dark ? "#fff" : tokens.ink, "& input::placeholder": { opacity: 0.7 } }}
        />
        <Button type="submit" disabled={state.busy}
          sx={{ whiteSpace: "nowrap", px: 2.5, background: dark ? tokens.cream : tokens.mossBtn, color: dark ? tokens.forestDark : "#fff", "&:hover": { background: dark ? "#fff" : "#4F5B43" } }}>
          {button}
        </Button>
      </Box>
      {note && <Typography sx={{ fontSize: 12.5, color: tokens.muted, mt: 1.25, ml: 1 }}>{note}</Typography>}
      {state.error && <Typography sx={{ fontSize: 13, color: tokens.outRange, mt: 1 }}>{state.error}</Typography>}
    </Box>
  );
}
